import React from 'react'
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'moment-timezone'
import { showMessage } from '../actions/messageBox'

class Timepick extends React.Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
        this.handleChangeString = this.handleChangeString.bind(this)
        this.textInput = HTMLInputElement
        this.state = {
            stringDate: props.selected,
            processedDate: moment(props.selected,'HH:mm:ss')
        }
    }

    handleChange(date, event) {
        
        let UTCDate = moment(date)
        let UTCDateStr = UTCDate.format('HH:mm:ss')


        let nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, "value").set
        nativeInputValueSetter.call(this.textInput, UTCDateStr)

        var ev2 = new Event('input', { bubbles: true })

        this.textInput.dispatchEvent(ev2)

        this.setState({
            processedDate: date,
            stringDate: UTCDateStr
        })

        let etval = document.getElementById("schedule.end_time_value")
        let stval = document.getElementById("schedule.start_time_value")
        let feedback = document.getElementById("schedule.end_time_feedback")
        let et = document.getElementById("schedule.end_time")
                  
        let tm = setTimeout(()=>{

            clearTimeout(tm)

            if ((etval.value) && (stval.value)) {

                if (etval.classList.contains("is-invalid")) {

                    etval.classList.remove("is-invalid")
                }

                feedback.innerHTML = ""
                if(et) {

                    et.classList.remove("is-invalid")
                } 

                if (etval.value < stval.value) { 

                    etval.classList.add("is-invalid")

                    feedback.innerHTML = "End Time must not be less than the Start Time."
                    
                    if(et) {

                        et.classList.add("is-invalid")
                    }
                }
            }
        }, 500)
    }

    handleChangeString(event) {
        // this.setState({ stringDate: event.target.value })
        this.props.onChange(event)
    }

    render() {


        return (
            <div className="test">
                <DatePicker
                    id={this.textInput.id + "_value"}
                    selected={Date.parse(this.state.processedDate)}
                    onChange={this.handleChange} 
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={1}
                    dateFormat="h:mm aa"
                    timeCaption="Time"
                    className={this.props.className||"form-control"}
                />
                <input type="text" className={`d-none ${this.props.className || "form-control"}`} onChange={this.handleChangeString} id={this.props.id} name={this.props.name} value={this.state.stringDate} ref={inp => { this.textInput = inp }} />
                <div id={this.textInput.id + "_feedback"} className="invalid-feedback">
                    {this.props.error}
                </div>
            </div>
        )
    }
}

export default Timepick


// WEBPACK FOOTER //
// ./src/components/timepick.js